import { PopoverPanel, Transition } from '@headlessui/react';
import { INetworkNode } from 'interfaces/network';
import { usePathname, useSearchParams } from 'next/navigation';
import { Fragment } from 'react';
import React from 'react';

import { CustomButtonLink } from '@/components/CustomButton';
import HeaderNetworkCard from '@/components/HeaderNetworkCard';
import HeaderViewAllButton from '@/components/HeaderViewAllButton';

export type TLinks = {
	displayName?: string;
	link?: string;
	openNewTab?: boolean;
} & Omit<INetworkNode, 'id'>;

export interface ISubMenuPopoverContentProps {
	dynamic: boolean;
	links: TLinks[];
	loading: boolean;
	isActive: boolean;
}

const SubMenuPopoverContent = ({
	dynamic,
	links,
	loading,
	isActive,
	close,
}: ISubMenuPopoverContentProps & {
	close: (e: any) => void;
}) => {
	const pathName = usePathname();
	const searchParams = useSearchParams();
	// const doraLink = `${pathName}?${searchParams}`;
	const cryptoCategory = searchParams.get('crypto_category');

	return (
		<Transition
			as={Fragment}
			enter="transition ease-out duration-200"
			enterFrom="opacity-0 translate-y-1"
			enterTo="opacity-100 translate-y-0"
			leave="transition ease-in duration-150"
			leaveFrom="opacity-100 translate-y-0"
			leaveTo="opacity-0 translate-y-1">
			<PopoverPanel
				data-testid="popover-content"
				className="absolute right-0 top-[4.5rem] z-10 w-full min-w-max max-w-max px-4 sm:px-0 lg:max-w-3xl lg:shadow-[0px_3px_5px_rgba(0,0,0,0.25)]">
				<div className="overflow-hidden rounded-lg shadow-lg">
					<div
						className={`relative bg-white p-4 dark:bg-midnight ${
							dynamic ? 'grid gap-4 lg:grid-cols-[repeat(2,1fr)]' : 'flex flex-col space-y-4'
						}`}>
						{dynamic ? (
							<>
								{(links as INetworkNode[]).map((link: INetworkNode) => (
									<div data-testid="popover-content-card" key={link.name} onClick={close}>
										<HeaderNetworkCard {...link} />
									</div>
								))}
								<div onClick={close}>
									<HeaderViewAllButton loading={loading} />
								</div>
							</>
						) : (
							(links as TLinks[]).map(({ displayName = '', link = '', openNewTab = false }) => {
								return (
									<CustomButtonLink
										useNextLink={!openNewTab}
										key={displayName}
										href={link}
										target="_blank"
										className={`flex !h-auto min-h-min items-center rounded-lg p-0 !text-header-gray outline-none transition duration-150 ease-in-out ${
											isActive ||
											(displayName === cryptoCategory && pathName === '/') ||
											(cryptoCategory === null && displayName === 'crypto' && pathName === '/')
												? '!text-midnight dark:!text-white'
												: 'hover:!text-midnight hover:dark:!text-white'
										}`}>
										<p className="text-sm font-medium capitalize tracking-wider !text-inherit" onClick={close}>
											{displayName}
										</p>
									</CustomButtonLink>
								);
							})
						)}
					</div>
				</div>
			</PopoverPanel>
		</Transition>
	);
};

export default React.memo(SubMenuPopoverContent);
